<!--  -->
<template>
  <!-- container`  `${!this.$root.miniprogram?'padding':''}`" -->
  <div :class="['container', { inMini: this.$root.miniprogram }]">
    <common-title titleName="学习笔记征集" :bcColor="'#FEFEFF'" :zIndex="1000" :goHome="true" />
    <div class="title">
      <p>
        《基础30讲》每学完一讲，将听课的学习笔记拍照上传，工作人员会进行收集汇总，对优秀学习笔记进行奖励。优秀笔记会安排做外化展示噢
      </p>
      <p>活动时间：截止至2024年5月31日</p>
    </div>
    <div class="common">
      <van-field
        v-model="fieldValue"
        label="学科"
        is-link
        readonly
        placeholder="请选择学科内容"
        @click="open"
      />
    </div>
    <div class="common">
      <p>笔记内容</p>
      <h3>请上传每一讲完整的内容哦，拍照请保持清晰</h3>
      <div class="cover" @click="checkLogin" v-if="!isLogin"></div>
      <UploadImage
        :maxNum="20"
        :ImgList="ImgList"
        @getListFile="getListFile"
        @deleteFile="deleteFile"
      />
    </div>
    <div class="submit" @click="submit">提交</div>
    <van-popup v-model="showPop" round position="bottom" @close="onClose" style="height: 60%">
      <van-cascader v-if="showPop" @close="onClose" :options="options" @change="onFinish" />
    </van-popup>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import axios from 'axios';
import UploadImage from './components/UploadImage/index.vue';

export default {
  components: {
    UploadImage,
  },
  data() {
    return {
      isLogin: localStorage.getItem('accessToken'),
      ImgList: [],
      selectedOptions: [],
      sourceFile: '',
      showPop: false,
      fieldValue: '',
      clickPoint: false,
      options: [
        {
          text: '高数',
          value: '01',
          children: [
            { text: '第1讲', value: '1' },
            { text: '第2讲', value: '2' },
            { text: '第3讲', value: '3' },
            { text: '第4讲', value: '4' },
            { text: '第5讲', value: '5' },
            { text: '第6讲', value: '6' },
            { text: '第7讲', value: '7' },
            { text: '第8讲', value: '8' },
            { text: '第9讲', value: '9' },
            { text: '第10讲', value: '10' },
            { text: '第11讲', value: '11' },
            { text: '第12讲', value: '12' },
            { text: '第13讲', value: '13' },
            { text: '第14讲', value: '14' },
            { text: '第15讲', value: '15' },
            { text: '第16讲', value: '16' },
            { text: '第17讲', value: '17' },
            { text: '第18讲', value: '18' },
          ],
        },
        {
          text: '线代',
          value: '02',
          children: [
            { text: '第1讲', value: '1' },
            { text: '第2讲', value: '2' },
            { text: '第3讲', value: '3' },
            { text: '第4讲', value: '4' },
            { text: '第5讲', value: '5' },
            { text: '第6讲', value: '6' },
          ],
        },
        {
          text: '概率',
          value: '03',
          children: [
            { text: '第1讲', value: '1' },
            { text: '第2讲', value: '2' },
            { text: '第3讲', value: '3' },
            { text: '第4讲', value: '4' },
            { text: '第5讲', value: '5' },
            { text: '第6讲', value: '6' },
          ],
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    checkLogin() {
      if (!this.$store?.state?.userInfo?.id) {
        if (this.$root.$data.isApp) {
          this.$sendToApp('login');
        } else if (this.$root.miniprogram) {
          const url = window.location.href;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        } else {
          const { path, query } = this.$route;
          this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
        }
        return false;
      }
      return true;
    },
    open() {
      if (!this.checkLogin()) return;
      this.showPop = true;
    },
    getListFile(file) {
      console.log(file, 111);
      this.sourceFile = file;
      this.compressImg(file);
    },
    deleteFile(index) {
      this.ImgList.splice(index, 1);
      console.log(this.ImgList);
    },
    onClose() {
      this.showPop = false;
    },

    onFinish(e) {
      const { selectedOptions } = e;
      if (selectedOptions.length === 2) {
        const fieldValue = selectedOptions.map((option) => option.text).join('/');
        this.showPop = false;
        this.fieldValue = fieldValue;
        this.selectedOptions = selectedOptions;
      }
    },
    /* @压缩公共方法
     * @params file
     * @return 压缩后的文件，支持两种，file和 blob
     */
    compressImg(file) {
      const reader = new FileReader();
      // readAsDataURL 方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成DONE，并触发 loadend (en-US) 事件，
      // 同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          // 图片的宽高
          const w = img.width;
          const h = img.height;
          const canvas = document.createElement('canvas');
          // canvas对图片进行裁剪，这里设置为图片的原始尺寸
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d');
          // canvas中，png转jpg会变黑底，所以先给canvas铺一张白底
          ctx.fillStyle = '#fff';
          // fillRect()方法绘制一个填充了内容的矩形，这个矩形的开始点（左上点）在
          // (x, y) ，它的宽度和高度分别由width 和 height 确定，填充样式由当前的fillStyle 决定。
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          // 绘制图像
          ctx.drawImage(img, 0, 0, w, h);

          // canvas转图片达到图片压缩效果
          // 返回一个包含图片展示的 data URI base64 在指定图片格式为 image/jpeg 或 image/webp的情况下，
          // 可以从 0 到 1 的区间内选择图片的质量。如果超出取值范围，将会使用默认值 0.92。其他参数会被忽略。
          const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
          this.dialogImageUrl = dataUrl;

          // base64格式文件转成file文件格式
          const fileName = this.sourceFile.name;
          const fileImg = this.dataURLtoFile(dataUrl, fileName);
          console.log('压缩后的图片：file文件----------');
          console.log(fileImg);
          this.ImgList.push(fileImg);
        };
      };
    },
    // canvas生成的格式为base64，需要进行转化, base64->file
    dataURLtoFile(dataurl, fileName) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },
    async submit() {
      if (!this.fieldValue) {
        this.$toast('请选择学科');
        return;
      }
      if (!this.ImgList.length) {
        this.$toast('请上传笔记');
        return;
      }
      if (this.clickPoint) return;
      this.clickPoint = true;
      const path = `${window.location.origin}/api/ark/web/zy-note/batch-add`;
      // const path = `https://mobile-test.iqihang.com/api/ark/web/zy-note/batch-add`;
      const formData = new FormData();
      this.ImgList.forEach((item) => {
        formData.append('file', item);
      });
      formData.append('subject', this.selectedOptions[0]?.text);
      formData.append('chapter', this.selectedOptions[1]?.text);
      axios({
        url: path,
        method: 'POST',
        data: formData,
        'Content-Type': 'multipart/form-data',
      }).then((res) => {
        const { code, msg } = res.data;
        if (code === 0) {
          this.$toast('上传成功');
          this.fieldValue = '';
          this.ImgList = [];
        } else {
          this.$toast(msg);
        }
        this.clickPoint = false;
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.inMini.container {
  padding-top: 36px;
}
.container {
  padding: 120px 36px 130px 36px;
  background: #f7f8fc;
  .title {
    width: 678px;
    height: 216px;
    margin-bottom: 22px;
    padding: 29px;
    background: url('../../assets/img/public/notes.png') no-repeat center center;
    background-size: contain;
    p {
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 40px;
    }
  }
  .cover {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 200px;
  }
  .common {
    position: relative;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 14px;
    .van-cell {
      border-radius: 14px;
    }
    > p {
      padding: 30px 0;
      padding-left: 29px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
    }
    h3 {
      padding-bottom: 20px;
      padding-left: 29px;
      color: #666;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
    }
  }
  .listImg {
    position: relative;
    width: 30%;
    height: 210px;
    margin-right: 1.5%;
    margin-bottom: 1.5%;
    ::v-deep .van-image__img {
      border-radius: 10px;
    }
    .closeIcon {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 29px;
      height: 29px;
    }
  }
  .rereadUpImg {
    padding: 29px 0 29px 29px;
  }
  ::v-deep.rereadUpImg .example {
    display: none !important;
  }
  .submit {
    position: fixed;
    right: 0;
    bottom: 40px;
    left: 0;
    width: 678px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border-radius: 45px;
  }
}
</style>
